import React from 'react';
import Select from 'react-select'; //select box for filter
//http requests
import axios from 'axios';
//state
import { decorate, observable, computed, action } from 'mobx';
import { observer } from 'mobx-react';
//utility
import {zeroNull, extractToken} from '../../services/Utilities';

//handles rendring form components and their validation
class DiscountBaseSelection extends React.Component {

  mobxState = {
    discountBaseSelect: [], //options for select box
  }

  //mount data through http requests
  componentDidMount() {
    //call the data loader to load data into the view
    this.fetchData();
  }

  //CHECK PROJECT ID

  //////////////////HTTP/////////////////
  //data loader
  fetchData = () => {
    ////////////////////
    //FORM LOAD
    //OPERATORS:
    axios.get('/microservices/v1/discountBases', {params: {} }) //test route, this will eventually go to db
    .then((response) => {
      this.mobxState.discountBaseSelect = response.data.discountBases;
      // console.log('INSIDE COMPONENT');
      console.log(this.mobxState.discountBaseSelect);
    });
    //END FORM LOAD
    //////////////////

  } //end fetchData()
 

  render(){

    // const validate = value => {
    //   return !value || value.length < 3 ? 'Must be at least three characters' : null;
    // }

    return (
      <div>
        <b>Discount Base</b>
        <Select
          onChange={(e) => this.props.handleFormChange(this.props.formField, e)}
          options={this.mobxState.discountBaseSelect}
          closeMenuOnSelect={true}
          maxMenuHeight = {400}
          placeholder={'percent'}
        />
      </div>
    )
  }

}

// when using decorate, all fields should be specified (a class might have many more non-observable internal fields after all)
decorate(DiscountBaseSelection, {
	mobxState: observable
})

export default observer(DiscountBaseSelection);

// export default ConstraintBaseSelection
